/*
  Desktop mega menu (LB-015 winner, native). The panels are rendered by Liquid; this file only adds
  hover intent and keyboard support on top of the theme's dropdown behaviour:
  - hover intent: a panel opens after a short pause (at once when another panel is already open)
    and stays open briefly after the pointer leaves, so crossing the nav does not flash panels;
  - keyboard: Enter on a top-level link opens its panel (theme.js), Escape closes it and returns
    focus to the link, and moving focus out of an item closes its panel.
  Delegated on ul#nav so items added later (Coframe LB-058 "Shop by Scent") behave the same way.
*/
(function () {
  var nav = document.getElementById('nav');
  if (!nav || nav.tagName !== 'UL' || !nav.querySelector(':scope > li > ul.cf-mega-menu')) return;

  var desktop = window.matchMedia('(min-width: 990px)');
  var OPEN_DELAY = 120;
  var CLOSE_DELAY = 200;
  var openTimer = null;
  var closeTimer = null;
  var current = null;

  function itemOf(target) {
    var li = target && target.closest ? target.closest('#nav > li') : null;
    return li && li.querySelector(':scope > ul.cf-mega-menu') ? li : null;
  }

  function open(li) {
    clearTimeout(openTimer);
    clearTimeout(closeTimer);
    if (current && current !== li) close(current);
    li.classList.add('cf-mega-open');
    li.setAttribute('aria-expanded', 'true');
    current = li;
  }

  function close(li) {
    li.classList.remove('cf-mega-open', 'navigation__menuitem--active');
    li.setAttribute('aria-expanded', 'false');
    if (current === li) current = null;
  }

  nav.classList.add('cf-mega-js');

  nav.addEventListener('mouseover', function (event) {
    if (!desktop.matches) return;
    var li = itemOf(event.target);
    if (!li) return;
    clearTimeout(closeTimer);
    if (li === current) return;
    clearTimeout(openTimer);
    if (current) open(li);
    else openTimer = setTimeout(function () { open(li); }, OPEN_DELAY);
  });

  nav.addEventListener('mouseout', function (event) {
    var li = itemOf(event.target);
    if (!li || li.contains(event.relatedTarget)) return;
    clearTimeout(openTimer);
    if (li !== current) return;
    closeTimer = setTimeout(function () { close(li); }, CLOSE_DELAY);
  });

  nav.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var li = itemOf(event.target);
    if (!li) return;
    close(li);
    var link = li.querySelector(':scope > a');
    if (link) link.focus();
  });

  nav.addEventListener('focusout', function (event) {
    var li = itemOf(event.target);
    if (li && !li.contains(event.relatedTarget)) close(li);
  });
})();
